import classNames from 'classnames'
import styles from './Loading.module.scss'

export const Loading = ({ inBtn }) => {
  return (
    <div
      className={classNames({
        [styles.loading]: !inBtn,
        [styles.btnLoading]: inBtn,
      })}
    >
      <div
        className={classNames(styles.container, {
          [styles.btnContainer]: inBtn,
        })}
      >
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
      </div>
    </div>
  )
}
